import { ThunkDispatch } from '@reduxjs/toolkit';
import React, { FC, ReactNode, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAndLoadConfig, selectAppConfig } from 'src/state/app/appConfigSlice';

export interface IAppConfigLoaderProps {
  children: ReactNode;
}

/**
 * The App requires state to operate. That state comes from config files fetched from the
 * server. While redux handles that fetch, the fetch could take time, and while it's
 * happening the App can't load...because it requires the configuration being loaded.
 *
 * This provides a visual indicator that something is happening while preventing its
 * children from loading until configuration is available.
 *
 * @param props
 * @constructor
 */
const AppConfigLoader: FC<IAppConfigLoaderProps> = (props) => {
  const { children } = props;
  const appConfig = useSelector(selectAppConfig);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  useEffect(() => {
    dispatch(fetchAndLoadConfig());
  }, [dispatch]);

  if (!appConfig.loadedAt) {
    return null;
  }

  return <>{children}</>;
};

export default AppConfigLoader;
